import { render, staticRenderFns } from "./carFlow.vue?vue&type=template&id=1c4b84dc&scoped=true&"
import script from "./carFlow.vue?vue&type=script&lang=js&"
export * from "./carFlow.vue?vue&type=script&lang=js&"
import style0 from "./carFlow.vue?vue&type=style&index=0&id=1c4b84dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b84dc",
  null
  
)

export default component.exports